import HttpFactory from '../factory'
import type { PractitionerContactPoint } from '../types/practitionerContactPoint'

class CommunicationModule extends HttpFactory<any[]> {
  private PATH = '/communications/practitioners/'
  private PHONE_PATH = '/v2/phone-calls'

  async getContactPoints(practitionerId: string): Promise<PractitionerContactPoint[]> {
    return await this.call<any>('GET', `${this.PATH}${practitionerId}/contact-points`)
  }

  async saveContactPoint(practitionerId: string, contactPoint: any): Promise<PractitionerContactPoint> {
    const newContactPoint = await this.getContactPoints(practitionerId)
    const url = `${this.PATH}${practitionerId}/contact-points`
    contactPoint.value = contactPoint.value.split(' ').join('')

    if (
      contactPoint.value.charAt(0) !== '+' &&
      contactPoint.value.charAt(0) === '0' &&
      contactPoint.type.system === 'phone' &&
      contactPoint.type.use !== '3cx'
    ) {
      contactPoint.value = contactPoint.value.replace('0', '+33')
    }
    if ((!contactPoint.value || contactPoint.value === '') && contactPoint.id) return this.deleteContactPoint(contactPoint)
    if (!contactPoint.revision) return this.call<any>('POST', url, contactPoint)
    else {
      const data: Partial<PractitionerContactPoint> = {}
      data.type = contactPoint.type
      data.value = contactPoint.value
      const headers: any = {}
      headers.params = {}
      headers.params.revision = newContactPoint.filter((f: any) => f.id === contactPoint.id)[0].revision
      return this.call<any>('PATCH', url + '/' + contactPoint.id, data, headers)
    }
  }
  deleteContactPoint(contactPoint: PractitionerContactPoint): Promise<PractitionerContactPoint> {
    const url = `${this.PATH}${contactPoint.practitionerId}/contact-points/${contactPoint.id}`
    const headers = {
      params: { revision: contactPoint.revision },
    }
    return this.call<any>('DELETE', url, headers)
  }

  async phoneCall(item: any) {
    return await this.call<any>('POST', `${this.PHONE_PATH}`, item)
  }
}

export default CommunicationModule
